module.exports = __webpack_public_path__ + "static/media/AreYouCurrentlyEmployed.41eb52ab.svg";